import { createContext, useContext, useState, useCallback } from "react";

const FormPopupContext = createContext(null);

export function FormPopupProvider({ children }) {
  const [popup, setPopup] = useState({ visible: false, form: [], formTitle: "", formDescription: "" });

  const openFormPopup = useCallback((form, formTitle = "", formDescription = "") => {
    setPopup({ visible: true, form: form || [], formTitle, formDescription });
  }, []);

  const closeFormPopup = useCallback(() => {
    setPopup({ visible: false, form: [], formTitle: "", formDescription: "" });
  }, []);

  return (
    <FormPopupContext.Provider value={{ popup, openFormPopup, closeFormPopup }}>
      {children}
    </FormPopupContext.Provider>
  );
}

export function useFormPopup() {
  const ctx = useContext(FormPopupContext);
  if (!ctx) throw new Error("useFormPopup must be used inside FormPopupProvider");
  return ctx;
}
